const historyDataActions = {
  HISTORY_INIT: 'HISTORY_INIT',
  HISTORY_SET: 'HISTORY_SET',
  HISTORY_VIEW_STATUS_SET: 'HISTORY_VIEW_STATUS_SET'
};
export default historyDataActions;
